import { Controller } from "@hotwired/stimulus"

// 비밀번호 표시/숨김 토글 컨트롤러
// 눈동자 아이콘 클릭 시 비밀번호 가시성 토글
export default class extends Controller {
  static targets = ["input", "showIcon", "hideIcon"]

  connect() {
    // 초기 상태: 비밀번호 숨김 (password type)
    this.visible = false
    this.updateIcons()
  }

  toggle() {
    this.visible = !this.visible

    if (this.visible) {
      this.inputTarget.type = "text"
    } else {
      this.inputTarget.type = "password"
    }

    this.updateIcons()
  }

  updateIcons() {
    if (this.visible) {
      // 비밀번호가 보이는 상태: hideIcon 표시 (눈에 사선)
      this.showIconTarget.classList.add("hidden")
      this.hideIconTarget.classList.remove("hidden")
    } else {
      // 비밀번호가 숨겨진 상태: showIcon 표시 (눈)
      this.showIconTarget.classList.remove("hidden")
      this.hideIconTarget.classList.add("hidden")
    }
  }
}
